import AchievementLogo from '../../../../../images/AOlogo.png';
import LeadershipLogo from '../../../../../images/LEOlogo.png';
import LearningLogo from '../../../../../images/LOlogo.png';
import NurturingLogo from '../../../../../images/NOlogo.png';
import RelationshipLogo from '../../../../../images/ROlogo.png';
import SwotIcon from '../../../../../images/swotIcon.png';
import guideTitle from '../../../../../images/guideTitle.png';
import learnTitle from '../../../../../images/learnTitle.png'
import collaborateTitle from '../../../../../images/collaborateTitle.png';

import achievement from '../../../../../images/achievement.png';
import sociability from '../../../../../images/sociability.png';
import leadership from '../../../../../images/leadership.png';
import learning from '../../../../../images/learning.png';
import integrity from '../../../../../images/integrity.png';
import strengthIcon from '../../../../../images/strengthIcon.png';
import weaknessIcon from '../../../../../images/weaknessIcon.png';
import opportunityIcon from '../../../../../images/opportunityIcon.png';
import threatIcon from '../../../../../images/threatIcon.png';


export const  buttonGroupData = [
    {
        img: SwotIcon,
        link: '/organisation/1/user/swot/0',
        name: "All",
        id: 0,
        tooltip_id:0
    },
    {
        img: achievement,
        link: '/organisation/1/user/swot/1',
        id:1,
        name: "Achievement",
        tooltip_id:1
    },
    {
        img: sociability,
        link: '/organisation/1/user/swot/2',
        id:2,
        name: "Relationship",
        tooltip_id:2
    },
    {
        img: leadership,
        link: '/organisation/1/user/swot/3',
        id:3,
        name: "Leadership",
        tooltip_id:3
    },
    {
        img: learning,
        link: '/organisation/1/user/swot/4',
        id:4,
        name: "Learning",
        tooltip_id:4
    },
    {
        img: integrity,
        link: '/organisation/1/user/swot/5',
        id:5,
        name: "Nurturing",
        tooltip_id:5
    },
]

export const  buttonGroupDataParameters = [
    {
        img: SwotIcon,
        link: '/organisation/1/user/swot/0',
        name: "All",
        id: 0,
        tooltip_id:0
    },
    {
        img: strengthIcon,
        link: '/organisation/1/user/swot/0/swot-detail/strength',
        id:"strength",
        name: "Strength",
        tooltip_id:1
    },
    {
        img: weaknessIcon,
        link: '/organisation/1/user/swot/0/swot-detail/weakness',
        id:"weakness",
        name: "Weakness",
        tooltip_id:2
    },
    {
        img: opportunityIcon,
        link: '/organisation/1/user/swot/0/swot-detail/opportunity',
        id:"opportunity",
        name: "Opportunity",
        tooltip_id:3
    },
    {
        img: threatIcon,
        link: '/organisation/1/user/swot/0/swot-detail/threat',
        id:"threat",
        name: "Threat",
        tooltip_id:4
    }
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/SWOT/SwotButtonGroupData.js